import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { tap, map, switchMap, finalize } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Table, TableFilterEvent } from 'primeng/table';
import { Title } from "@angular/platform-browser";
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { GlobalConnSettings, GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocListEntry} from 'src/app/shared/doc-list-entry';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-home-active-orders-list',
  templateUrl: './home-active-orders-list.component.html',
  styleUrls: ['./home-active-orders-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeActiveOrdersListComponent implements OnInit, OnDestroy, OnChanges {

  @Input() today: Date;
  @Input() clean: boolean = true;

  globalSettinsData: GlobalSettingsData;

  @ViewChild('ptable2') ptable2: Table;

  validOrdersList: DocListEntry[];

  validSelectedDocument: DocListEntry;
  validOrdersQuery: Subscription;
  totalValidOrders: number;
  private validOrdersSubj$ = new Subject<{ CLIID: number, DATEFROM: Date, DEEP: number, EXT: number }>();

  loading: boolean = false;

  totalInvoiceSum: number = 0;

  cf2: any = {};

  constructor(
    private restapi: RestApiService,
    private titleService: Title,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** HomeActiveOrdersListComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {
        case 'clean':
          this.clearSavedSettings();

        case 'today':
          if (this.globalSettinsData) {
            this.loading = true;
            this.validOrdersSubj$.next({ CLIID: this.globalSettinsData.mainCompanyId, DATEFROM: this.today, DEEP: 0, EXT: 0 });
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** HomeActiveOrdersListComponent in ngOnDestroy");

    if (this.validOrdersQuery) { this.validOrdersQuery.unsubscribe(); }
  }

  subscribeValidOrdersData(): void {
    this.validOrdersQuery =
      this.validOrdersSubj$
      .pipe(
        tap(() => this.loading = true),

        switchMap(option =>
          this.restapi.getValidOrdersList(option.CLIID, option.DEEP, option.DATEFROM, option.EXT ? true : false).pipe(
            tap(data => environment.production || console.table(data)),

            map(data => this.validOrdersList = data || []),

            finalize(() => {
              this.totalValidOrders = this.validOrdersList.length;
              this.docListCalculatedFields(this.validOrdersList);
              this.totalInvoiceSum = this.validOrdersList.reduce((s, e) => s += e.DOCSUM, 0);
              this.loading = false;
            })
      )))
        .subscribe({
          error: (err) => {
            console.error('Error occurred while fetching valid orders list:', err);
            this.loading = false;
          }
        });
  }

  ngOnInit(): void {
    console.log("*** HomeActiveOrdersListComponent in ngOnInit");
    
    this.titleService.setTitle('Активные заказы - домашняя страница');

    this.today = new Date();

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.subscribeValidOrdersData();
    this.validOrdersSubj$.next({ CLIID: this.globalSettinsData.mainCompanyId, DATEFROM: this.today, DEEP: 0, EXT: 0 });
  }

  onStateSave(state) {
    console.log('*** HomeActiveOrdersListComponent onStateSave: ' + JSON.stringify(state));
  }

  onValidRowSelect(event) {
    //console.log('*** DocumentsComponent onRowSelect: ' + JSON.stringify(event.data))
    //this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCID });
    //    this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCTYPEID });

  }

  onStateRestoreActive(state) {
    console.log('*** HomeActiveOrdersListComponent onStateRestoreActive: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        this.cf2[f] = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;
      }
    }
  }

  docListCalculatedFields(orderList: DocListEntry[]) {

    let jn: Date = new Date();
    let td: Date = new Date();
    td.setHours(0, 0, 0, 0);
    let tm: Date = new Date(td);
    tm.setHours(23, 59, 59);

    orderList.forEach((dc: DocListEntry) => {
      dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

      dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

      dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

      dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

      dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

      dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

      dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

      dc.fd = (new Date(dc.DOCDATE) > tm);
    });
  }

  onFilterEvent(event: TableFilterEvent) {
    console.log('*** HomeActiveOrdersListComponent onFilterEvent: ' + JSON.stringify(event));

    this.totalInvoiceSum = event.filteredValue.reduce((s, e) => s += e.DOCSUM, 0);
  }

  clearSavedSettings() {
    try {
      this.ptable2.clearState();
    } catch (e) {
      console.log('*** HomeActiveOrdersListComponent in clearSavedSettings: ' + JSON.stringify(e));
    }
    this.clean = false;
  }

  reloadTable(event) {
    console.log('*** HomeActiveOrdersListComponent reloadTable: ' + JSON.stringify(event));

    this.validOrdersSubj$.next({ CLIID: this.globalSettinsData.mainCompanyId, DATEFROM: this.today, DEEP: 0, EXT: 0 });
  }

  clearOrResetTableFilter(event) {
    console.log('*** HomeRecentOrdersListComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.clearSavedSettings();
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** HomeRecentOrdersListComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.validOrdersList);

      const exportData: any =
        this.validOrdersList.map(e => ({

          'Документ': e.DOCNAME,
          'Номер': e.DOCNUMBER,
          'Дата': new Date(e.DOCDATE),
          'Покупатель': e.CLIENTSNAME,
          'Ответственный': e.PERSONNAME,
          'Продавец': e.LOCALCOMP,
          'Менеджер': e.AUTHOR,
          'Сумма': e.DOCSUM,
          'Оплачено': e.PAYDSUM,
          'Отгружено': e.SHIPSUM,
          'Валюта': e.CURSTR,
          'Курс': e.DOCRATEVAL,
          'Примечание продавца': e.DOCNOTE1,
          'Примечание покупателя': e.DOCNOTE2,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { documents: worksheet }, SheetNames: ['documents'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "documents");
    });
  }
}
